import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { terminalDataSync } from '@/utils/terminalDataSync'
import { clearPendingFormDirtyAura, releasePendingFormDirtyAura } from '@/utils/formDirtyAura'

export default {
  get,
  post
}

function requestError (error) {
  const response = error.response
  const message = response && response.data && response.data.msg
  if (typeof message === 'string' && message.trim()) return new Error(message)
  if (!response) return new Error('网络连接失败，请检查网络后重试')
  if (response.status === 404) return new Error('接口不存在或服务尚未更新，请联系管理员')
  if (response.status >= 500) return new Error('服务器处理失败，请稍后重试')
  return new Error('请求失败（' + response.status + '），请检查后重试')
}
/**
 * @description: 异步 get方法 访问api
 * @return: json.data对象
 * @param {string} controller 控制器名称
 * @param {string} prefix 根据不同的参数 调用不同路径的接口
 */
async function get (controller, prefix = 'Plane') {
  const path = init(prefix)
  const requestToken = store.state.user.token
  try {
    const res = await axios.get(path + controller)
    if (res.data.status === 'noPermission' && requestToken === store.state.user.token) { // 权限过期
      await store.dispatch('user/destroyUserAsync')
      router.go(0)
    }
    return res
  } catch (error) {
    console.error('Error fetching data:', ['Login', 'Mqtt'].includes(prefix) ? '认证请求失败' : error)
    throw requestError(error)
  }
}
/**
 * @description: 异步 post方法 访问api
 * @return: json.data对象
 * @param {string} controller 控制器名称
 * @param {obj} params post参数
 * @param {string} prefix 根据不同的参数 调用不同路径的接口
 */
async function post (controller, params, prefix = 'Plane') {
  const path = init(prefix)
  const requestToken = store.state.user.token
  try {
    const res = await axios.post(path + controller, params)
    if (res.data.status === 'noPermission' && requestToken === store.state.user.token) { // 权限过期
      await store.dispatch('user/destroyUserAsync')
      router.go(0)
    }
    if (Number(res.data.status) === 1) {
      if (requestToken === store.state.user.token && Array.isArray(res.data.refresh_keys)) {
        terminalDataSync.invalidate(res.data.refresh_keys, requestToken)
      }
      clearPendingFormDirtyAura()
    } else releasePendingFormDirtyAura()
    return res
  } catch (error) {
    releasePendingFormDirtyAura()
    console.error('Error fetching data:', ['Login', 'Mqtt'].includes(prefix) ? '认证请求失败' : error)
    throw requestError(error)
  }
}
/**
 * @description: 判断访问常规还是登录接口路径 设置token头文件
 * @return {*} 接口路径
 * @param {string} prefix 根据不同的参数 调用不同路径的接口
 */
function init (prefix) {
  // axios缺省设置
  axios.defaults.baseURL = store.state.settings.baseURL
  // axios.defaults.headers.post['Content-Type'] = 'application/json'
  let path
  if (prefix === 'Plane') {
    axios.defaults.headers.common.Token = store.state.user.token
    path = store.state.settings.apiPlanePath
  } else if (prefix === 'Admin') {
    axios.defaults.headers.common.Token = store.state.user.token
    path = store.state.settings.apiAdminPath
  } else if (prefix === 'God') {
    axios.defaults.headers.common.Token = store.state.user.token
    path = store.state.settings.apiGodPath
  } else if (prefix === 'Pay') {
    axios.defaults.headers.common.Token = store.state.user.token
    path = store.state.settings.apiPayPath
  } else if (prefix === 'Mqtt') {
    axios.defaults.headers.common.Token = store.state.user.token
    path = '/mpApi/Mqtt/'
  } else if (prefix === 'Login') {
    axios.defaults.headers.common.Token = 'login'
    path = store.state.settings.apiLoginPath
  } else if (prefix === 'App') {
    delete axios.defaults.headers.common.Token
    path = store.state.settings.apiAppPath
  }
  return path
}
